module.exports = __webpack_public_path__ + "img/new_artwork_promotion_email.b54bc42f.png";